import { PersonPicker } from "Components/_Shared/Inputs/PersonPicker/PersonPicker";
import type { ComponentProps } from "react";
import { type Control, Controller, type FieldPath, type FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues> = Omit<ComponentProps<typeof PersonPicker>, "value" | "onChange" | "error"> & {
  readonly name: FieldPath<FormType>;
  readonly control: Control<FormType>;
};

export const FormPersonPicker = <FormType extends FieldValues>({ name, control, ...rest }: Props<FormType>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <PersonPicker {...rest} value={field.value ?? ""} onChange={field.onChange} error={fieldState.error?.message} />
    )}
  />
);
